import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Videos } from './components/Videos';
import { Features } from './components/Features';
import { Location } from './components/Location';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
export function App() {
  return <div className="font-inter bg-gris-oscuro text-blanco min-h-screen" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <Services data-id="element-3" />
      <Videos data-id="element-4" />
      <Features data-id="element-5" />
      <Location data-id="element-6" />
      <CTA data-id="element-7" />
      <Footer data-id="element-8" />
      <WhatsAppFloat data-id="element-9" />
    </div>;
}